var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuslang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#F0F0F0;}\r\n\t.st2{fill:#0052B4;}\r\n\t.st3{fill:#D80027;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: -0.1,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16,31.9c8.8,0,16-7.2,16-16c0-8.8-7.2-16-16-16S0,7,0,15.9C0,24.7,7.1,31.9,16,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31,21.4c0.6-1.7,1-3.6,1-5.6c0-2-0.4-3.8-1-5.6H1c-0.6,1.7-1,3.6-1,5.6c0,2,0.4,3.8,1,5.6l15,1.4L31,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16,31.9c6.9,0,12.7-4.3,15-10.4H1C3.2,27.5,9.1,31.9,16,31.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuslang);
export default __webpack_public_path__ + "static/media/ruslang.c9a52682d415af387c55f1b6af1216db.svg";
export { ForwardRef as ReactComponent };